import debounce from 'lodash.debounce'
import { Search } from 'lucide-react'

import { Input } from '@/_components/ui/input'
import { cn } from '@/_lib/utils'
import { useSearchParams } from '@/features/_hooks/use-search-params'

interface InlineSearchboxProps {
  search: string
  placeholder?: string
  className?: string
  disabled?: boolean
}

export function InlineSearchbox({
  search,
  placeholder,
  className,
  disabled,
}: InlineSearchboxProps) {
  const { setSearchParam } = useSearchParams()

  return (
    <div className={cn('relative', className)}>
      <Search
        className="absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground"
        size={16}
      />
      <Input
        className="h-9 w-[320px] pl-8"
        onChange={(e) => debounce(() => setSearchParam('search', e.target.value), 500)()}
        type="search"
        defaultValue={search}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  )
}
